import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { mapToMapExpression } from '@angular/compiler/src/render3/util';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HorarioUsuario, Usuario } from 'src/app/models/usuario';
import { environment } from 'src/environments/environment';
import { PermisoModulos } from '../models/permisoModulo/permisoModulo';
import { Proyecto } from '../models/proyecto';
import { HttprService } from './httpr.service';

@Injectable({ providedIn: 'root' })
export class UsuarioService {
    public actual: Usuario;
    public v: any;
    private userSubject = new BehaviorSubject<any>(null);
    public user$ = this.userSubject.asObservable();
    private initialized = false;

    constructor(private http: HttpClient) {
        this.initializeUser();
    }

    private initializeUser() {
        if (!this.initialized) {
            this.actual = JSON.parse(localStorage.getItem("usLog"));
            this.setUser(this.actual);
            this.initialized = true;
        }
    }

    recuperaTokenCompartir(code: string, rp: string, idProyecto: number, idEmpresaAfiliada: number = -1, idCampana: number = -1): Observable<string> {
        var url = environment.apiUrl;

        return this.http.get(url + "/users/recupera-token-compartir?code=" +
            code +
            "&rp=" +
            rp +
            "&IdEmpresaAfiliada=" +
            idEmpresaAfiliada.toString() +
            "&IdCampana=" +
            idCampana.toString() +
            "&IdProyecto=" +
            idProyecto.toString(), {
            responseType: 'text', headers: {

                'Content-Type': 'application/text',
                'Authorization': `Bearer ${this.actual?.token}`
            }
        });
    }

    recuperaUrlCompartir(code: string, rp: string, idProyecto: number, urlCompleta: string, idAsesor: Number, funcionalidad: number): Observable<string> {
        var url = environment.apiUrl;

        return this.http.get(url + "/users/genera-url?code=" +
            code +
            "&rp=" +
            rp +
            "&IdProyecto=" +
            idProyecto.toString() +
            "&url=" +
            urlCompleta +
            "&IdAsesor=" +
            idAsesor.toString() +
            "&funcionalidad=" +
            funcionalidad.toString(), {
            responseType: 'text', headers: {

                'Content-Type': 'application/text',
                'Authorization': `Bearer ${this.actual?.token}`
            }
        });
    }


    recuperaVistasPermisos() {
        var url = environment.apiUrl;
        var usuario = new Usuario();
        usuario.idUsuarioUM = this.actual.idUsuario;

        return this.http.post<any>((url + "/users/RecuperaVistas"), usuario, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        }).pipe(
            catchError(errorRes => {
                return throwError(errorRes);
            })
        );
    }

    recuperaUsuariosProyecto(idProyecto: number, nombre: string, perfil: string) {

        var url = environment.apiUrl;

        var proyecto = new Proyecto();
        proyecto.idProyecto = idProyecto;
        proyecto.nombre = nombre;

        return this.http.post<Usuario[]>((url + "/users/recuperaUsuariosProyecto"), proyecto, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        }).pipe(
            catchError(errorRes => {
                return throwError(errorRes);
            })
        );
    }

    recuperaUsuariosProyectoLinea(idProyecto: number) {
        // Construye la URL con los parámetros del proyecto
        var url = environment.apiUrl;
        const params = {
            idGrupoTelefono: idProyecto.toString(),
        };

        // Realiza la solicitud GET con los parámetros
        return this.http.get<Usuario[]>(url + "/campanas/recupera-usuarios-campana", {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
            params // Envía los parámetros en la URL
        }).pipe(
            catchError(errorRes => {
                console.error('Error recuperando usuarios del proyecto:', errorRes);
                return throwError(() => errorRes);
            })
        );
    }

    setUser(user: any) {
        if (user !== this.userSubject.getValue()) {
            this.userSubject.next(user);
        }
    }

    getUser() {
        return this.userSubject.getValue();
    }

    guardarHorarioUsuario(horario = new HorarioUsuario()) {
        horario.horaInicioString = horario.horaInicio;
        horario.horaFinString = horario.horaFin;

        var url = environment.apiUrl;
        return this.http.post<any>(url + "/users/guardar-horario-usuario", horario, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        });
    }

    recuperaHorariosUsuario(idUsuario: number) {
        var url = environment.apiUrl;
        return this.http.get<any>(url + "/users/recupera-horario-usuario", {
            params: new HttpParams().set('idUsuario', idUsuario.toString()),
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        }).pipe(
            catchError(errorRes => {
                return throwError(errorRes);
            })
        );
    }

    eliminarHorarioUsuario(horario: HorarioUsuario) {
        var url = environment.apiUrl;
        return this.http.delete<any>(url + "/users/elimina-horario-usuario", {
            params: new HttpParams().set('idHorario', horario.idHorario.toString()).set('idUsuario', horario.idUsuario.toString()).set('diaSemana', horario.diaSemana.toString()),
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        }).pipe(
            catchError(errorRes => {
                return throwError(errorRes);
            })
        );
    }

    eliminarUsuarioLineaAutomatizacion(idGrupoTelefono: number, idAutomatizacion: number, idUsuario: number) {
        var url = environment.apiUrl;
        return this.http.delete<any>(url + "/users/elimina-usuario-automatizacion", {
            params: new HttpParams().set('idLinea', idGrupoTelefono.toString()).set('idAutomatizacion', idAutomatizacion.toString()).set('idUsuario', idUsuario.toString()),
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.actual?.token}`
            }),
        }).pipe(
            catchError(errorRes => {
                return throwError(errorRes);
            })
        );
    }

    // recuperaTokenCompartir(code: string, rp: string, idProyecto: number) {
    //     var url = environment.apiUrl;
    //     return this.http.get<string>((url + "/users/recupera-token-compartir?code=" +
    //         code +
    //         "&rp=" +
    //         rp +
    //         "&IdProyecto=" +
    //         idProyecto.toString()), {
    //         headers: {
    //             'Content-Type': 'application/text',
    //             'Authorization': `Bearer ${this.actual.token}`
    //         },
    //     }).pipe(map(res => {
    //         console.log("res", res.toString());
    //         return res.toString();
    //     }));
    // }
}
